<label iccLabel>
    {{ 'PRICE_VERSION|Wersja cenowa:' | translate }}
</label>

<icc-select
    size="small"
    name="priceVersions"
    [value]='"" + activatedPriceVersion?.id'
    (valueChange)="onPriceVersionSelected($event)"
    #priceVersionSelector
>
    <option *ngFor='let priceVersion of allPriceVersions$ | async'
        [value]="priceVersion?.id"
        [selected]="+priceVersion?.id === +activatedPriceVersion?.id"
    >
        <span *ngIf='+actualPriceVersion?.id === +priceVersion?.id' translate>PRICE_VERSION|(Aktualna)</span> {{ priceVersion?.name }}
    </option>
</icc-select>

<div class="price-version-dates">
    <span *ngIf='activatedPriceVersion?.effectiveDate' [class.invalid]="invalidVersionEffectiveDate">
        {{ 'INTERFACE|Od:' | translate }} {{ activatedPriceVersion?.effectiveDate | date : 'short' }}
    </span>
    <span *ngIf='activatedPriceVersion?.expiredDate' [class.invalid]="invalidVersionExpiredDate">
        {{ 'INTERFACE|Do:' | translate }} {{ activatedPriceVersion?.expiredDate | date : 'short' }}
    </span>
</div>
